import React from 'react';
import { useUserFilters } from '../../hooks/useUserFilters';
import { useMetadata } from '../../context/MetadataContext';
import styles from './FilterPanel.module.css';

const FilterPanel = ({ isOpen, onClose }) => {
  // fetches the filters when the panel opens
  const { filters, setFilters, loading, saving, error, saveFilters } = useUserFilters(isOpen);
  const { metadata, loading: metadataLoading } = useMetadata();

  // Handle checkbox change
  const handleCheckboxChange = (filterType, value) => {
    setFilters(prev => {
      const updated = prev ? { ...prev } : {};
      updated[filterType] = updated[filterType] || [];
      if (updated[filterType].includes(value)) {
        updated[filterType] = updated[filterType].filter(v => v !== value);
      } else {
        updated[filterType] = [...updated[filterType], value];
      }
      return updated;
    });
  };

  // Apply filters to backend
  const handleApply = () => saveFilters(onClose); // closes the panel once saved

  if (!isOpen) return null;

  return (
    <div className={styles.filterOverlay} onClick={onClose}>
      <div className={styles.filterPanel} onClick={e => e.stopPropagation()}>
        <h2>Filters</h2>
        {loading || metadataLoading ? (
          <div className={styles.loading}>Loading...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : filters && metadata ? (
          <>
            {/* Style Filter */}
            <div className={styles.filterSection}>
              <h3>{metadata.style_filter.name}</h3>
              {metadata.style_filter.values.map(value => (
                <label key={value} className={styles.filterOption}>
                  <input
                    type="checkbox"
                    checked={filters.style?.includes(value) || false}
                    onChange={() => handleCheckboxChange('style', value)}
                  />
                  <span className={styles.filterOptionLabel}>{value}</span>
                </label>
              ))}
            </div>
            {/* Size Filter */}
            <div className={styles.filterSection}>
              <h3>{metadata.size_filter.name}</h3>
              {metadata.size_filter.values.map(value => (
                <label key={value} className={styles.filterOption}>
                  <input
                    type="checkbox"
                    checked={filters.size?.includes(value) || false}
                    onChange={() => handleCheckboxChange('size', value)}
                  />
                  <span className={styles.filterOptionLabel}>{value}x{value}</span>
                </label>
              ))}
            </div>
            {/* Difficulty Filter */}
            <div className={styles.filterSection}>
              <h3>{metadata.difficulty_filter.name}</h3>
              {metadata.difficulty_filter.values.map(value => (
                <label key={value} className={styles.filterOption}>
                  <input
                    type="checkbox"
                    checked={filters.difficulty?.includes(value) || false}
                    onChange={() => handleCheckboxChange('difficulty', value)}
                  />
                  <span className={styles.filterOptionLabel}>{value}</span>
                </label>
              ))}
            </div>
            <div className={styles.filterActionsFooter}>
              <button className={styles.cancelButton} onClick={onClose} disabled={saving}>
                Cancel
              </button>
              <button className={styles.applyButton} onClick={handleApply} disabled={saving}>
                {saving ? 'Saving...' : 'Apply'}
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default FilterPanel;
                      